(function () {
    'use strict';

    /* A subscription is remembered in this browser for three months, as
       {email, until} under chz-nl. While it lasts, the newsletter block shows
       only its message, the header's Subscribe link is hidden (.nl-subscribed,
       which the head script in partial/ds-styles also sets before the first
       paint) and the unsupported-language dialog says the person is
       subscribed, with no form. Every new subscription starts the three
       months again. The key used to hold the bare address with no end date;
       such a value is dropped, not carried over. */
    var STORAGE_KEY = 'chz-nl';
    var REMEMBER_MONTHS = 3;

    function readSubscription() {
        try {
            var raw = window.localStorage.getItem(STORAGE_KEY);
            if (!raw) return null;
            var saved = JSON.parse(raw);
            if (saved && typeof saved.email === 'string' && saved.until > Date.now()) return saved;
            window.localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
            try { window.localStorage.removeItem(STORAGE_KEY); } catch (ignored) {}
        }
        return null;
    }

    function markPage() {
        var root = document.documentElement;
        if (root.classList.contains('nl-subscribed')) return;
        root.classList.add('nl-subscribed');
        // the header measures its row again without the Subscribe link
        // (ios-cleaner.js fits it on resize)
        window.dispatchEvent(new Event('resize'));
    }

    function rememberSubscription(email) {
        var until = new Date();
        until.setMonth(until.getMonth() + REMEMBER_MONTHS);
        try {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ email: email, until: until.getTime() }));
        } catch (error) {}
        markPage();
    }

    /* The address this browser subscribed with in the last three months, for
       the dialog's Notify me button (unsupported-language-modal.js). */
    window.newsletterSavedEmail = function () {
        var saved = readSubscription();
        return saved ? saved.email : '';
    };

    function initializeNewsletter(form, saved) {
        var email = form.querySelector('input[name="email"]');
        var button = form.querySelector('button[type="submit"]');
        var note = form.parentElement.querySelector('.js-newsletter-note');
        var csrf = form.querySelector('input[name="_token"]');
        // the embedded humanizer (/i-humanizer) has no csrf.js to fill the
        // field; its meta carries the token from the start
        var csrfMeta = document.querySelector('meta[name="csrf-token"]');
        // the unsupported-language dialog decides for itself what a
        // subscribed person sees (unsupported-language-modal.js)
        var asksForLanguage = form.hasAttribute('data-language-request');

        if (!email || !button || !note) return;

        /* A subscribed person sees the message alone: the field and the
           button go (.is-done), and the message takes the place of the
           privacy line in the note. takeFocus: the focus was in the form,
           whose controls are now gone, so the message takes it. */
        function markSubscribed(message, takeFocus) {
            button.disabled = true;
            email.disabled = true;
            form.classList.add('is-done');
            note.textContent = message;
            // a failed try before this one leaves its class behind
            note.classList.remove('error');
            note.classList.add('ok');
            if (takeFocus) {
                note.tabIndex = -1;
                note.focus({ preventScroll: true });
            }
        }

        if (form.dataset.subscribed === 'true') {
            markSubscribed(form.dataset.subscribedMessage);
            return;
        }

        if (!email.value && saved) email.value = saved.email;

        if (saved && !asksForLanguage) {
            markSubscribed(form.dataset.subscribedMessage);
            return;
        }

        // a subscription made in another form on the page (the dialog) counts
        // here at once, not only from the next page on
        if (!asksForLanguage) {
            document.addEventListener('newsletter:subscribed', function () {
                if (!form.classList.contains('is-done')) markSubscribed(form.dataset.subscribedMessage);
            });
        }

        /* The unsupported-language dialog asks again for every language it
           is opened for: it sends newsletter:reset, and the form is ready for
           another subscription. */
        var initialNote = note.innerHTML;
        form.addEventListener('newsletter:reset', function () {
            form.classList.remove('is-done');
            button.disabled = false;
            email.disabled = false;
            email.removeAttribute('aria-invalid');
            note.innerHTML = initialNote;
            note.classList.remove('ok', 'error');
        });

        /* newsletter:done and newsletter:failed tell the dialog how its
           Notify me button went: that button sends this form while it is
           hidden, so it does not see the form's own messages. */
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            var value = email.value.trim();
            var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
            email.setAttribute('aria-invalid', String(!valid));
            if (!valid) {
                email.focus();
                form.dispatchEvent(new CustomEvent('newsletter:failed'));
                return;
            }

            /* Asked before the button is disabled: a disabled button drops
               the focus to the page, and a dialog must keep it. */
            var focusWasInside = form.contains(document.activeElement);
            button.disabled = true;
            form.classList.add('is-loading');

            // and whatever else the form carries (the dialog's
            // requested_language and tool) when it is filled in
            var fields = { email: value };
            form.querySelectorAll('input[type="hidden"]').forEach(function (field) {
                if (field.name !== '_token' && field.value) fields[field.name] = field.value;
            });

            window.fetch(form.action, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': (csrf && csrf.value) || (csrfMeta && csrfMeta.content) || ''
                },
                body: JSON.stringify(fields)
            }).then(function (response) {
                return response.json().catch(function () { return {}; }).then(function (payload) {
                    if (!response.ok) throw new Error(payload.message || form.dataset.errorMessage);
                    return payload;
                });
            }).then(function (payload) {
                rememberSubscription(value);
                markSubscribed(payload.message || form.dataset.successMessage, focusWasInside);
                form.dispatchEvent(new CustomEvent('newsletter:done'));
                document.dispatchEvent(new CustomEvent('newsletter:subscribed'));
            }).catch(function (error) {
                button.disabled = false;
                note.textContent = error.message || form.dataset.errorMessage;
                note.classList.remove('ok');
                note.classList.add('error');
                if (focusWasInside) email.focus();
                form.dispatchEvent(new CustomEvent('newsletter:failed'));
            }).finally(function () {
                form.classList.remove('is-loading');
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        var saved = readSubscription();
        // the embedded humanizer has no head script of its own
        if (saved) markPage();
        document.querySelectorAll('.js-newsletter-form').forEach(function (form) {
            initializeNewsletter(form, saved);
        });
    });
})();
